import React from "react";
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { Row, Col, Clearfix } from 'react-bootstrap';

import { RenderTextArea } from "shared/render-field";
import { currentUser } from "helpers/User";

import { validate } from 'form-validations/validation-callback-form';
import { CALLBACK_FORM_NAME } from "helpers/FormNames";

class CallbackForm extends React.Component {
  componentDidMount() {
    const { autofill } = this.props;
    autofill('estimator', currentUser().id);
  }

  render() {
    const { submitting, handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit} autoComplete="off" className="note-form">
        <Row>
          <div className="flex-center-align">
            <Col md={9}>
              <Field name="note" label="Comments" component={RenderTextArea} />
            </Col>
            <Col md={3}>
              <button className="btn btn-success" type="submit" disabled={submitting}>Add a callback</button>
            </Col>
          </div>
        </Row>
      </form>
    )
  }
}

CallbackForm = reduxForm({
  form: CALLBACK_FORM_NAME,
  validate,
  enableReinitialize: true
})(CallbackForm);

CallbackForm = connect(
  state => ({
    users: state.users,
    initialValues: {
      estimator: currentUser().id
    }
  })
)(CallbackForm);

CallbackForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  autofill: PropTypes.func.isRequired
};

export default CallbackForm;
